<h2>{{ translationService.getSubstancesOfConcernText() }}</h2>

@if (mandatorySubstancesOfConcern && mandatorySubstancesOfConcern.length > 0) {
  <p>
    {{ translationService.getSubstancesPresentMandatoryText() }}
    <a
      href="https://www.canada.ca/en/environment-climate-change/corporate/transparency/consultations/labelling-toxic.html"
      target="_blank"
      >{{ translationService.getEnvironmentCanadaMandatoryText() }}:</a
    >
  </p>
  <table class="mat-table">
    <thead>
      <tr>
        <th>{{ translationService.getNameText() }}</th>
        <th>{{ translationService.getCasHashtagText() }}</th>
        <th>{{ translationService.getConcentrationRangeText() }}</th>
      </tr>
    </thead>
    <tbody>
      @for (ingredient of mandatorySubstancesOfConcern; track ingredient) {
        <tr>
          <td>{{ ingredient.name }}</td>
          <td>{{ ingredient.casNumbers }}</td>
          <td>
            @if (
              ingredient.lowerConcentration && ingredient.upperConcentration
            ) {
              {{ ingredient.lowerConcentration }} -
              {{ ingredient.upperConcentration }} %
            } @else {
              {{ translationService.getNaText() }}
            }
          </td>
        </tr>
      }
    </tbody>
  </table>
}

@if (voluntarySubstancesOfConcern && voluntarySubstancesOfConcern.length > 0) {
  <p>
    {{ translationService.getSubstancesPresentVoluntaryText() }}
    <a
      href="https://www.canada.ca/en/environment-climate-change/services/canadian-environmental-protection-act-registry/guidelines-objectives-codes-practice/environmentally-sound-management-chemical-substances.html"
      target="_blank"
      >{{ translationService.getEnvironmentCanadaVoluntaryText() }}:</a
    >
  </p>
  <table class="mat-table">
    <thead>
      <tr>
        <th>{{ translationService.getNameText() }}</th>
        <th>{{ translationService.getCasHashtagText() }}</th>
        <th>{{ translationService.getConcentrationRangeText() }}</th>
      </tr>
    </thead>
    <tbody>
      @for (ingredient of voluntarySubstancesOfConcern; track ingredient) {
        <tr>
          <td>{{ ingredient.name }}</td>
          <td>{{ ingredient.casNumbers }}</td>
          <td>
            @if (
              ingredient.lowerConcentration && ingredient.upperConcentration
            ) {
              {{ ingredient.lowerConcentration }} -
              {{ ingredient.upperConcentration }} %
            } @else {
              {{ translationService.getNaText() }}
            }
          </td>
        </tr>
      }
    </tbody>
  </table>
}
